import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { showSuccessToast, showErrorToast } from '@ui';
import { consumePendingToast } from '@utils/pendingToast';

// This is for this to be above the Intercom launcher
const zIndex = 2147483647;

export default function RootToaster() {
  // Shows any toast queued (via setPendingToast) by a page right before a
  // full-page redirect, so a confirmation like "Material & Service Updated!"
  // survives navigation instead of being torn down with the previous page.
  useEffect(() => {
    const pending = consumePendingToast();
    if (!pending) return;

    if (pending.variant === 'error') showErrorToast(pending.message);
    else showSuccessToast(pending.message);
  }, []);

  return <Toaster position="bottom-right" containerStyle={{ zIndex }} />;
}
